// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"MyTimeoffManagement_cardTitle__1bTcH","periodContainer":"MyTimeoffManagement_periodContainer__2g4LC","actionsContainer":"MyTimeoffManagement_actionsContainer__3m89f"};